import { OnboardingStatus } from './types';

export const getOnboardingStatus = async ({
  accessToken
}: {
  accessToken: string;
}): Promise<OnboardingStatus> => {
  const response = await fetch('/backend/teams/onboarding_status', {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
  if (!response.ok) throw await response.json();

  return (await response.json()) as Promise<OnboardingStatus>;
};

export const skipOnboarding = async ({ accessToken }: { accessToken: string }): Promise<void> => {
  const response = await fetch('/backend/teams/onboarding_status', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) throw await response.json();
};
